import XLSX from "xlsx-js-style"
import Excel from "exceljs"
import jsPDF from "jspdf"
import intl from "react-intl-universal"

import "jspdf-autotable"
import { fnFormatDateFromUTC } from "./date"
import moment from "moment"
import useDataApi from "../hooks/useDataApi"
import { fnExportBoard } from "../services/boards"  
import axios from "axios"
import Column from "antd/es/table/Column"

export function fnOrganizeValues(
  values,
  nBoardId,
  cUserTimeZone,
  oMappedFields,
  aResponsibles,
  aInvolveds,
  headers,
) {
  const data = values.map((value) => {
    const check = {
      Pending: "Pendente",
      Done: "Concluído",
      Masculino: "Masculino",
      Feminino: "Feminino",
    }
    switch (oMappedFields[value.opfv_opfd_nid]) {
      case "NUMBER":
        if (value.opfv_cvalue) {
          const cValue = String(value.opfv_cvalue)
          if (cValue.includes(',')) {
            return {
              id: value.opfv_opfd_nid,
              value: value.opfv_cvalue.replace(",", ","),
              position: value.opfv_nposition,
            }
          } else {
            return {
              id: value.opfv_opfd_nid,
              value: Number(value.opfv_cvalue),
              position: value.opfv_nposition,
            }
          }

        }
        return {
          id: value.opfv_opfd_nid,
          value: Number(value.opfv_cvalue),
          position: value.opfv_nposition,
        }
      case "SELECTION":
        if (value.selected_option) {
          return {
            id: value.opfv_opfd_nid,
            value:
              check[value.selected_option.opfs_coption_name] ??
              value.selected_option.opfs_coption_name,
            position: value.opfv_nposition,
          }
        }
        return {
          id: value.opfv_opfd_nid,
          value: "",
          position: value.opfv_nposition,
        }
      case "DATE":
        if (value.opfv_cvalue) {
          return {
            id: value.opfv_opfd_nid,
            value: moment.utc(value.opfv_cvalue).tz(cUserTimeZone).toDate(),
            position: value.opfv_nposition,
          }
        }
        return {
          id: value.opfv_opfd_nid,
          value: "-",
          position: value.opfv_nposition,
        }

      case "PEOPLES":
        if (value.opfv_opfd_nid) {
          if (value?.field?.opfd_cslug === "act_responsibles") {
            return {
              id: value.opfv_opfd_nid,
              value: aResponsibles.map((user) => user.user_cname).join(" / "),
              position: value.opfv_nposition,
            }
          }
          if (value?.field?.opfd_cslug === "act_involveds") {
            return {
              id: value.opfv_opfd_nid,
              value: aInvolveds?.map((user) => user.user_cname).join(" / "),
              position: value.opfv_nposition,
            }
          }
          return {
            id: value.opfv_opfd_nid,
            value: value?.opfv_cvalue?.map((user) => user.user_cname).join(" / "),
            position: value.opfv_nposition,
          }
        }
        return {
          id: value.opfv_opfd_nid,
          value: "",
          position: value.opfv_nposition,
        }
      default:
        return {
          id: value.opfv_opfd_nid,
          value: value.opfv_cvalue,
          position: value.opfv_nposition,
        }
    }
  })
  for (let header of headers) {
    let isUndefinedData = data.find((item) => item.id === header.id) === undefined

    if (isUndefinedData && header?.slug === "act_responsibles") {
      data.push({
        id: header.id,
        value: aResponsibles.map((user) => user.user_cname).join(" / "),
        position: null,
      })
    }
    if (isUndefinedData && header.slug === "act_involveds") {
      data.push({
        id: header.id,
        value: aInvolveds.map((user) => user.user_cname).join(" / "),
        position: null,
      })
    }
  }
  return [...data, { id: "id", value: nBoardId }]
}
export function fnOrganizeHeaders(oBoard, oBlock, nBlockViewMode) {
  
  const aBooardModelFields = oBoard?.board_model?.fields || []
  const aBlockTableHiddenFields = oBlock?.table_hidden_fields || []
  const aBlockKanbanHiddenFields = oBlock?.kanban_hidden_fields || []
  const aHiddenFields = nBlockViewMode === 1 ? aBlockKanbanHiddenFields : aBlockTableHiddenFields

  const visibleFields = aBooardModelFields.filter((f) => !aHiddenFields.find(h => h?.ophf_ombf_nid === f?.ombf_nid))
  return visibleFields
    .map(({field}) => {
        return {
          id: field.opfd_nid,
          name: field.opfd_cname,
          position: field.opvf_nposition,
          prefix: field.opfd_cprefix,
          sufix: field.opfd_csuffix,
          type: field.opfd_ctype,
          slug: field.opfd_cslug,
        }
    })
}

// Worksheet names cannot contain any of the following characters: / \ ? * : [ ]
function fnRemoveSheetNameInvalidCharacteres(cInputString, nBlockId) {
  /* eslint-disable no-useless-escape */
  const cFilteredInputString = cInputString.replace(/[\\,\/,\?,\*,\:,\[,\]]/g, "")
  const cBlockName = `${nBlockId} - ${cFilteredInputString}`
  return cBlockName?.substring(0, 30)
}

//Crie uma função que verifica o nome do block e caso ele seja maior que 31 caracteres retorna apenas os 30 primeiros caracteres

export function fnHandleGetDataToExport(aBlocks, cUserTimeZone, oBoard, nBlockViewMode) {
  return aBlocks?.map((block, i) => {
    const oMappedFields = {}
    const aBooardModelFields = oBoard?.board_model?.fields || []
    for (const field of aBooardModelFields) {
      oMappedFields[field?.field?.opfd_nid] = field?.field?.opfd_ctype
    }
    const blockName = fnRemoveSheetNameInvalidCharacteres(block.opbl_cname, block.opbl_nid)
    const headers = fnOrganizeHeaders(oBoard, block, nBlockViewMode)
    const activities = block?.activities || []
    let values = activities.map((activity) =>
      fnOrganizeValues(
        activity.values,
        activity.opat_nid,
        cUserTimeZone,
        oMappedFields,
        activity.responsibles,
        activity.involveds,
        headers,
      ),
    )

    const uniqueHeaders = []
    const headerCounts = {}

    headers.forEach((header) => {
      const name = `${header.id} - ${header.name} ${header.prefix
        ? "( " + header.prefix + " )"
        : header.sufix
          ? "( " + header.sufix + " )"
          : ""
        }`

      if (!headerCounts[name]) {
        uniqueHeaders.push(name)
        headerCounts[name] = 1
      } else {
        const uniqueName = `${name} ${headerCounts[name]}`
        uniqueHeaders.push(uniqueName)
        headerCounts[name]++
      }
    })

    uniqueHeaders.unshift("Id")

    const parsedUniqueHeaders = uniqueHeaders.map((item) => {
      if (item === "Id") {
        return item
      } else {
        return item.split("-")?.slice(1)?.join("-")?.trim()
      }
    })
    const resultArray = [parsedUniqueHeaders]

    values.forEach((row) => {
      const newRow = []
      uniqueHeaders.forEach((header) => {
        if (header === "Id") {
          newRow.push(row.find((item) => item.id === "id").value)
        } else {
          let id = header.split("-")[0].trim()
          const headerInfo = headers.find((h) => String(h.id) === id)
          if (headerInfo) {
            newRow.push(row.find((item) => item.id === headerInfo.id)?.value || "-")
          } else {
            newRow.push("")
          }
        }
      })
      resultArray.push(newRow)
    })
    const aEmptyRow = [[], [], []]
    resultArray.unshift(...aEmptyRow);
  resultArray.push(...aEmptyRow);
    return { name: blockName, data: resultArray }
  })
}
async function imageUrlToBase64(url) {
  try {
      const response = await fetch(url);
      if (!response.ok) {
          throw new Error('Erro ao carregar a imagem');
      }
      const blob = await response.blob();
      const reader = new FileReader();
      const base64Promise = new Promise((resolve, reject) => {
          reader.onloadend = () => {
              const base64 = reader.result.replace(/^data:.+;base64,/, '');
              resolve(base64);
          };
          reader.onerror = reject;
      });
      reader.readAsDataURL(blob);
      return await base64Promise;
  } catch (error) {
      console.error('Erro ao converter a imagem para base64:', error);
      throw error;
  }
}

export async function fnHandleExportToXlsx(oBoard, cUserTimeZone, aBlocks, oUser, custLogo, nBlockViewMode) {
  const data = fnHandleGetDataToExport(aBlocks, cUserTimeZone, oBoard, nBlockViewMode)
  const workbook = new Excel.Workbook()
  const imageBuffer =  await imageUrlToBase64(custLogo)
  const imageLogo = workbook.addImage({
    base64: imageBuffer,
    extension: "png",
  })
  data.forEach((block, id) => {
    const worksheet = workbook.addWorksheet(block.name)
    worksheet.headerFooter = {
      oddHeader: '&G',
      oddFooter: intl.get('board.export.footer', {date: fnFormatDateFromUTC(new Date(), "DD/MM/YYYY - HH:mm", cUserTimeZone), user: oUser.data.user_cname}),
      alignWithMargins: false,
      differentFirst: false,
      differentOddEven: false,
      scaleWithDoc: true,
      alignLeft: true,
      alignCenter: false,
      alignRight: false,
      fontColor: { rgb: "3B454F" }
      
    }
    
    //adding value to header cells
    worksheet.getCell('B2').value = oUser.data.customer.cust_cname
    worksheet.getCell('B3').value = String(oUser.data.customer.cust_ctype === "PJ" ? oUser.data.customer.cust_ccnpj : oUser.data.customer.cust_ccpf);
    worksheet.getCell('B4').value = oUser.data.user_cname;
    //styling header cells
    worksheet.getCell('A1').alignment = { horizontal: 'Benter', vertical: 'middle' };
    worksheet.getCell('A1').font = { bold: true, size: 14 };
    worksheet.getCell('B2').alignment = { horizontal: 'left', vertical: 'middle' };
    worksheet.getCell('B2').font = { bold: true, size: 14, color: { argb: "22272D" } };
    worksheet.getCell('B3').alignment = { horizontal: 'left', vertical: 'middle' };
    worksheet.getCell('B3').font = { bold: true, size: 12, color: { argb: '3B454F'} };
    worksheet.getCell('B4').alignment = { horizontal: 'left', vertical: 'middle' };
    worksheet.getCell('B4').font = { bold: true, size: 10, color: { argb: '5A646E'} };
   
    worksheet.columns = block.data[0].map((header, index) => ({ header }))
    block.data.slice(1).forEach((row) => {
      row.forEach((value, index) => {
      if (typeof value === 'object' && moment(value).isValid()) {
        row[index] = String(moment(value).format('DD/MM/YYYY - HH:mm:ss'));
      }
      });
      worksheet.addRow(row);
    })
    
    worksheet.getRow(7).eachCell({ includeEmpty: true }, (cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFF" } }
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "6CB6E3" } }
    })
    worksheet.getColumn('A').alignment = { horizontal: 'left', vertical: 'middle' };
    worksheet.columns.forEach((column) => {
      
      let maxColWidth = 0
      column.eachCell({ includeEmpty: true }, (cell) => {
      const cellText = moment(cell.text).isValid() ?  String(moment(cell.text).format("DD/MM/YYYY - HH:mm:ss")) : String(cell.text) || String(cell.value)
      let cellWidth = cellText.length + 2 // Add extra space
      if (cell.type === Excel.ValueType.Date) {
        cellWidth = 23
      }
      if (cellWidth > maxColWidth) {
        maxColWidth = cellWidth
      }
      })
      column.width = maxColWidth
    })
    // Add logo on header
    worksheet.addImage(imageLogo, {
      tl: {col: 0, row: 0},
      ext: {width: 100, height: 100},
      editAs: 'oneCell',
      position: {
      type: 'oneCellAnchor',
      from: {
        col: 5, // Adjust the column number as needed
        colOff: 0,
        row: 0, // Adjust the row number as needed
        rowOff: 0
      }
      }
    })
    // Merge cells
    worksheet.mergeCells('A1:A5') // Space to logo
    worksheet.mergeCells('C1:F5')
    // Add border to merged cells
    worksheet.getCell('A1:A5').border = {
      right: { style: "thin" },
    };
    
    worksheet.getCell('B1').border = {
      top: { style: "thin" },
    }
    worksheet.getCell('B5').border = {
      bottom: { style: "thin" },
    }
    worksheet.getCell('C1:F5').border= {
      top: { style: "thin" },
      right: { style: "thin" }, 
      bottom: { style: "thin" },
    }

    worksheet.views = [
      {
        state: 'frozen',
        xSplit: 0,
        ySplit: 7,
      }
    ]
    worksheet.pageSetup.printTitlesRow = '1:7';
    
  })
  await workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
    const url = URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = `${oBoard.name} (${fnFormatDateFromUTC(new Date(), "DD/MM/YYYY - HH:mm", cUserTimeZone)}).xlsx`
    a.click()
  })
}

export function fnHandleExportToPdf(aBlocks, cUserTimeZone) {
  const tableData = fnHandleGetDataToExport(aBlocks, cUserTimeZone)
  const doc = jsPDF("p", "px", "A3")

  let startY = 10 // Inicialize com a posição Y desejada para a primeira tabela

  tableData.forEach((table) => {
    // Adicione um título para a tabela
    doc.setFontSize(12)
    doc.text(20, startY, table.name)
    doc.setFontSize(10)

    // Defina as colunas da tabela
    const columns = Object.keys(table.data[0])

    // Defina os dados da tabela
    const tableRows = table.data.map((row) => {
      return columns.map((col) => row[col])
    })

    // Crie a tabela no PDF usando jspdf-autotable
    doc.autoTable({
      head: [columns],
      body: tableRows,
      tableWidth: "auto",
      startY: startY + 5, // Ajuste o espaço entre o título e a tabela
    })

    // Atualize a posição Y para a próxima tabela
    startY = doc.lastAutoTable.finalY + 15 // Adicione espaço vertical adicional
  })

  // Salve ou exiba o PDF
  doc.save("document.pdf")
}
